/*
 * User-facing text for the Loans service's problem codes (hli-lists and abroad-loans) that the
 * scholarships API does not have or means otherwise; the rest read as there (scholarshipProblems.js).
 * The API's `detail` is never shown.
 */
const MESSAGES = {
  // Institutions and bursaries
  "ownership-not-set": "HEC has not yet said whether your institution is public or private.",
  "public-institution": "A public institution uploads its admitted students instead of keeping a list.",
  "verification-failed": "We could not verify these details. Check your registration number and national ID, or contact support.",
  "too-many-attempts": "Too many unsuccessful attempts. Please try again later.",
  "already-linked": "This account is already linked to a bursary record.",
  "record-already-claimed": "This record is already linked to an account.",
  "account-not-found": "There is no such account.",
  "not-claimed": "Claim your bursary record first.",
  "requests-closed": "Your institution is not taking bursary requests now.",
  "already-requested": "You have already asked for a bursary.",
  "claim-pending": "Your earlier claim is still being reviewed.",
  "invalid-decision": "Choose to grant or reject.",
  "selection-approved": "This selection is approved and can no longer change.",
  "selection-verified": "This selection is verified: return it before running it again.",
  "invalid-transition": "This selection cannot move to that step now.",

  // Private institutions' lists
  "duplicate-student": "A student is on the list twice: each registration number once.",
  "list-empty": "Add the students before submitting.",
  "list-not-found": "There is no such list.",
  "not-private": "A public institution decides its students itself; the list is not sent to HEC.",

  // Abroad loan calls and programmes
  "programme-exists": "This programme is already in the catalogue.",
  "programme-not-found": "There is no such programme.",
  "unknown-level": "Choose an education level from the list.",
  "unknown-programme": "A programme offered is no longer in the catalogue.",
  "call-not-found": "There is no such loan call.",
  "call-not-draft": "Only a draft call can change its programmes or be published.",
  "call-not-editable": "A published call keeps its visibility and academic year, and its opening date once open.",
  "call-cancelled": "This loan call is cancelled.",
  "call-incomplete": "The call is not ready: it needs at least one programme, criteria weighing 100 in all for each, and a closing date still ahead.",
  "invalid-offer": "Check the programmes: each is offered once, its criteria weigh at most 100 and every rule has a value.",

  // Abroad loan applications
  "call-closed": "This loan call is no longer taking applications.",
  "before-start": "The end date must be after the start date.",
  "decided": "A decision has been made on this application, so it can no longer be withdrawn.",
  "not-sent": "This application was never sent: cancel it instead.",
  "not-draft": "This application has been sent and can no longer be changed here.",
  "not-reopenable": "This application can no longer be changed: the call has closed or it is being decided.",
  "deadline-passed": "The call has closed, so the application can no longer change.",
  "changed-meanwhile": "It was changed in the meantime. Reload the page and try again.",
  "application-not-found": "There is no such application.",
  "document-not-available": "The file is still being checked, or it failed the check.",

  // Abroad loan review and award list
  "unknown-person": "There is no HEC staff account with this ID.",
  "evaluator-not-assigned": "This evaluator is no longer on the call's committee.",
  "call-not-closed": "The award list can be made once the call has closed.",
  "award-list-not-found": "This call has no award list yet.",
  "separation-of-duties": "You are on this call's review committee, so someone else must send the award list.",
  "approved-amounts-required": "Set the approved loan (currency and tuition fee) for every awarded student.",
  "entries-incomplete": "Every submitted application must be on the list once; reload it and check the reserve ranks.",

  // Abroad loan decisions and letters
  "reason-required": "Say why: the student sees the reason.",
  "not-your-turn": "Only whoever holds the application now may change its amounts.",
  "letter-not-found": "There is no approval letter for this application yet.",

  // Abroad loan awards: the student's answer and travel, BRD's ticket and payments
  "award-not-found": "There is no approved loan for this application.",
  "already-answered": "You have already answered.",
  "not-approved": "This loan has not been approved yet.",
  "not-accepted": "The student has not accepted this loan yet.",
  "invalid-travel": "Check the travel details.",
  "invalid-ticket": "Check the ticket details: the airline, the flight number, the departure and the file.",
  "invalid-payment": "Check the payment: it cannot be dated in the future.",
  "payment-not-found": "This payment was already removed.",
  "document-not-found": "This file is no longer available.",
  "message-required": "Write a message first.",
};

export const loansProblemMessage = (code) => (code ? MESSAGES[code] ?? null : null);
